/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import classnames from 'classnames';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import Filters from './filters';

import styles from '../styles/categoryNavigatorFilters.module.scss';

const CategoryNavigatorFilters = ({
  filters = [],
  filtersClassName = '',
  hasCustomFilterButton = false,
  isCustomFilterButtonDisabled = false,
  isDisabled = false,
  onClearFiltersClick = () => {},
  onCustomFilterClick = () => {},
  onFilterClick = () => {},
  selectedFilterValues = {},
  shouldAnimateFilters = true,
  shouldShowClearFilters = false,
  shouldShowFilters = false,
}) => {
  const ParentElement = shouldAnimateFilters ? AnimatePresence : Fragment;
  const ChildElement = shouldAnimateFilters ? motion.div : Fragment;
  const childElementProps = shouldAnimateFilters
    ? {
        initial: { opacity: 0, height: 0 },
        animate: { opacity: 1, height: 'auto' },
        exit: { opacity: 0, height: 0 },
        transition: { ease: 'easeInOut', duration: 0.2 },
      }
    : {};

  return (
    <ParentElement>
      {shouldShowFilters && (
        <ChildElement {...childElementProps}>
          <Filters
            className={classnames(styles.element, filtersClassName)}
            clearButtonIcon={<CloseOutlinedIcon />}
            hasCustomFilterButton={hasCustomFilterButton}
            isCustomFilterButtonDisabled={isCustomFilterButtonDisabled}
            isDisabled={isDisabled}
            onCustomFilterClick={onCustomFilterClick}
            onSelectionUpdate={onFilterClick}
            onClearButtonClick={onClearFiltersClick}
            hasClearButton={shouldShowClearFilters}
            filters={filters}
            position="left"
            selection={selectedFilterValues}
          />
        </ChildElement>
      )}
    </ParentElement>
  );
};

CategoryNavigatorFilters.propTypes = {
  hasCustomFilterButton: PropTypes.bool,
  isCustomFilterButtonDisabled: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onCustomFilterClick: PropTypes.func,
  onFilterClick: PropTypes.func,
  onClearFiltersClick: PropTypes.func,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      value: PropTypes.any,
      placeholder: PropTypes.string,
      isMulti: PropTypes.bool,
      isSearchable: PropTypes.bool,
      text: PropTypes.string,
    }),
  ),
  shouldShowFilters: PropTypes.bool,
  shouldShowClearFilters: PropTypes.bool,
  shouldAnimateFilters: PropTypes.bool,
  filtersClassName: PropTypes.string,
  selectedFilterValues: PropTypes.shape({}),
};

export default React.memo(CategoryNavigatorFilters);
